import { ValidationDialogOpenState } from './State'
import { IValidationUserResponses } from 'types/UserResponses'

export const SET_IS_DIALOG_OPEN = 'validationButton.setIsDialogOpen'
export const SET_IS_INITIATIVE_ALERT_OPEN = 'validationButton.setIsInitiativeAlertOpen'
export const SET_VALIDATION_OPTIONS = 'validationButton.setValidationOptions'
export const RESET = 'validationButton.reset'

export function setIsDialogOpen(payload: ValidationDialogOpenState) {
  return {
    type: SET_IS_DIALOG_OPEN,
    payload
  } as const
}

export function setIsInitiativeAlertOpen(payload: ValidationDialogOpenState) {
  return {
    type: SET_IS_INITIATIVE_ALERT_OPEN,
    payload
  } as const
}

export function setValidationOptions(validation: IValidationUserResponses) {
  return {
    type: SET_VALIDATION_OPTIONS,
    payload: {
      validation
    }
  } as const
}

export function reset() {
  return {
    type: RESET,
    payload: {}
  } as const
}

export type ValidationDialogActions = ReturnType<
  typeof setIsDialogOpen | typeof setIsInitiativeAlertOpen | typeof setValidationOptions | typeof reset
>
